import React from 'react';
import {Typography, useMediaQuery, useTheme} from "@mui/material";

function SubTitle(props) {

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <Typography variant={isMobile?"h3":"h1"} {...props}>{props.children}</Typography>
    );
}

export default SubTitle;